// Standard vehicle inspection checklist items
export const INSPECTION_CHECKLIST_ITEMS = [
    // Exterior
    { category: "Exterior", name: "Front Bumper" },
    { category: "Exterior", name: "Rear Bumper" },
    { category: "Exterior", name: "Left Side Body" },
    { category: "Exterior", name: "Right Side Body" },
    { category: "Exterior", name: "Roof" },
    { category: "Exterior", name: "Hood/Bonnet" },
    { category: "Exterior", name: "Trunk/Boot" },

    // Interior
    { category: "Interior", name: "Dashboard" },
    { category: "Interior", name: "Steering Wheel" },
    { category: "Interior", name: "Front Seats" },
    { category: "Interior", name: "Rear Seats" },
    { category: "Interior", name: "Upholstery" },
    { category: "Interior", name: "Carpet/Floor Mats" },
    { category: "Interior", name: "Center Console" },

    // Mirror & Plate
    { category: "Mirror & Plate", name: "Left Side Mirror" },
    { category: "Mirror & Plate", name: "Right Side Mirror" },
    { category: "Mirror & Plate", name: "Rear View Mirror" },
    { category: "Mirror & Plate", name: "Front License Plate" },
    { category: "Mirror & Plate", name: "Rear License Plate" },

    // Tyres
    { category: "Tyres", name: "Front Left Tire" },
    { category: "Tyres", name: "Front Right Tire" },
    { category: "Tyres", name: "Rear Left Tire" },
    { category: "Tyres", name: "Rear Right Tire" },
    { category: "Tyres", name: "Spare Tire" },
    { category: "Tyres", name: "Wheel Rims" },

    // Glass & Lights
    { category: "Glass & Lights", name: "Windshield" },
    { category: "Glass & Lights", name: "Rear Window" },
    { category: "Glass & Lights", name: "Side Windows" },
    { category: "Glass & Lights", name: "Headlights" },
    { category: "Glass & Lights", name: "Taillights" },
    { category: "Glass & Lights", name: "Indicators/Turn Signals" },
] as const;

export const INSPECTION_CATEGORIES = [
    { key: "Exterior", label: "Exterior", icon: "car-outline" },
    { key: "Interior", label: "Interior", icon: "bed-outline" },
    { key: "Mirror & Plate", label: "Mirror & Plate", icon: "construct-outline" },
    { key: "Tyres", label: "Tyres", icon: "ellipse-outline" },
    { key: "Glass & Lights", label: "Glass & Lights", icon: "flash-outline" },
] as const;

export const FUEL_LEVELS = [
    { value: "empty", label: "Empty", shortLabel: "E", color: "#EF4444" },
    { value: "quarter", label: "Quarter", shortLabel: "1/4", color: "#F97316" },
    { value: "half", label: "Half", shortLabel: "1/2", color: "#EAB308" },
    { value: "three_quarters", label: "3/4", shortLabel: "3/4", color: "#84CC16" },
    { value: "full", label: "Full", shortLabel: "F", color: "#0FB9B1" },
] as const;

export const CONDITION_OPTIONS = [
    { value: "excellent", label: "Excellent", color: "#10B981", badgeBg: "#D1FAE5", badgeText: "#059669", icon: "checkmark" as const },
    { value: "fair", label: "Fair", color: "#F59E0B", badgeBg: "#FEF3C7", badgeText: "#D97706", icon: "warning" as const },
    { value: "damaged", label: "Damaged", color: "#EF4444", badgeBg: "#FEE2E2", badgeText: "#DC2626", icon: "close" as const },
] as const;
